// SummaryCards.jsx 
const SummaryCards = ({ summary }) => {
  const cards = [
    {
      title: "Total Team Members",
      value: summary?.totalMembers || 0,
      icon: "bx bx-user-circle",
      color: "primary",
      trend: "+12%",
      trendPositive: true
    },
    {
      title: "Currently Working",
      value: summary?.working || 0,
      icon: "bx bx-briefcase-alt",
      color: "success",
      trend: "+5%",
      trendPositive: true
    },
    {
      title: "Currently on Break",
      value: summary?.break || 0,
      icon: "bx bx-coffee",
      color: "warning",
      trend: "-2%",
      trendPositive: false
    },
    {
      title: "Offline Members",
      value: summary?.offline || 0,
      icon: "bx bx-time-five",
      color: "danger",
      trend: "-8%",
      trendPositive: false
    },
  ];

  return (
    <div className="summary-cards-grid">
      {cards.map((card, index) => (
        <div 
          key={index} 
          className={`summary-card summary-card-${card.color}`}
          style={{
            backgroundColor: 'var(--bg-primary)',
            color: 'var(--text-primary)'
          }}
        >
          <div className="summary-card-header">
            <div className={`summary-card-icon ${card.color}`}>
              <i className={card.icon}></i>
            </div>
          </div>
          <div className="summary-card-content">
            <h3 
              className="summary-card-value"
              style={{ color: 'var(--text-primary)' }}
            >
              {card.value}
            </h3>
            <p 
              className="summary-card-label"
              style={{ color: 'var(--text-secondary)' }}
            >
              {card.title}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;